// extracted by mini-css-extract-plugin
export var divider = "_g6-7";
export var itemsToggle = "_g6-8";
export var mergeModal = "_g6-1";
export var optionCard = "_g6-4";
export var radioGroup = "_g6-6";
export var radioOption = "_g6-0";
export var selected = "_g6-5";
export var shipmentOptions = "_g6-2";
export var tableOptions = "_g6-3";